<section class="site-footer">
  <div class="site-footer-primary">
    <div class="container">
      <div class="row">
        <div class="col-md-12 footer-leftnav">
          <div class="row footer-nav">
            <div class="col-lg-3 col-6">
              <section class="footer-nav-block">
                <div class="title" role="link" tabindex="0">Workforce Solutions </div>
                <nav role="list">
                  <div role="listitem">
                    <a class="" href="https://www.manpowergroup.co.in/permanent-recruitment.html" target="_blank">Permanent Recruitment</a>
                  </div>
                  <div role="listitem">
                    <a class="" href="https://www.manpowergroup.co.in/contract-staffing.html" target="_blank">Contract Staffing</a>
                  </div>
                  <div role="listitem">
                    <a class="" href="https://www.manpowergroup.co.in/workforce-management.html" target="_blank">Workforce Transformation</a>
                  </div>
                  <div role="listitem">
                    <a class="" href="https://www.manpowergroup.co.in/it-services.html" target="_blank">IT Services</a>
                  </div>
                  <div role="listitem">
                    <a class="" href="https://www.manpowergroup.co.in/vendor-management-staffing.html" target="_blank">Vendor Management Services</a>
                  </div>
                  <div role="listitem">
                    <a class="" href="https://rotostat.in/" target="_blank">Industrial Engineering Services</a>
                  </div>
                </nav>
              </section>
            </div>
            <div class="col-lg-3 col-6">
              <section class="footer-nav-block">
                <div class="title" role="link" tabindex="0">Insights</div>
                <nav role="list">
                  <div role="listitem"><a href="https://www.manpowergroup.co.in/thought-leadership.html" target="_blank" class="" title="Thought Leadership"
                      rel="noopener noreferrer">Thought Leadership</a></div>
                  <div role="listitem"><a href="https://www.manpowergroup.co.in/success-stories.html" target="_blank" class="" title="Success Stories"
                      rel="noopener noreferrer">Success Stories</a></div>
                  <div role="listitem"><a href="https://www.manpowergroup.co.in/blog/blog-home.html" target="_blank" class="" title="Blogs"
                      rel="noopener noreferrer">Blogs</a></div>
                </nav>
              </section>
            </div>
            <div class="col-lg-3 col-6">
              <section class="footer-nav-block">
                <div class="title" role="link" tabindex="0">Job Opportunities</div>
                <nav role="list">
                  <div role="listitem"><a class="" routerLink="/jobs">Apply for Job</a></div>
                </nav>
              </section>

            </div>
            <div class="col-lg-3 col-6">
              <section class="footer-nav-block">
                <div class="title" role="link" tabindex="0">About Us</div>
                <nav role="list">
                  <div role="listitem"><a class="" href="https://www.manpowergroup.co.in/aboutus.html" target="_blank">About Manpower</a></div>
                  <div role="listitem"><a class="" href="https://www.manpowergroup.co.in/global-operations.html" target="_blank">Global Network</a></div>
                  <div role="listitem"><a class="" href="https://www.manpowergroup.co.in/media-center.html" target="_blank">Media Center</a></div>
                  <div role="listitem"><a class="" href="https://www.manpowergroup.co.in/contact.aspx" target="_blank">Contact us</a></div>
                </nav>
              </section>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="footer-disclaimer">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">

          <div class="disclaimer-logo__list disclaimer-logo__list--secondary">
            <span class="disclaimer-logo__item disclaimer-logo__item--2 mx-2">
              <a href="https://www.manpower.com" class="" target="_blank" rel="noopener noreferrer"
                aria-label="Manpower opens in a new tab">
                <img alt="Manpower" width="62" height="50" src="assets/Manpower-Logo-Stacked-White.svg"></a></span>
            <span class="disclaimer-logo__item disclaimer-logo__item--3 mx-2">
              <a href="https://www.experis.com" class="" target="_blank" rel="noopener noreferrer"
                aria-label="Experis Manpower Group opens in a new tab">
                <img alt="Experis Manpower Group" width="45" height="56"
                  src="assets/Experis-Logo-Stacked-White.svg"></a></span>
            <span class="disclaimer-logo__item disclaimer-logo__item--4 mx-2">
              <a href="https://talentsolutions.manpowergroup.com" class="" target="_blank" rel="noopener noreferrer"
                aria-label="ManpowerGroup Talent Solutions logo opens in a new tab">
                <img alt="ManpowerGroup Talent Solutions logo" width="55" height="72"
                  src="assets/Talent-Solutions-Logo-Stacked-White.svg"></a></span>
            <span class="disclaimer-logo__item disclaimer-logo__item--4 mx-2">
              <a href="https://rotostat.in" class="" target="_blank" rel="noopener noreferrer"
                aria-label="Rotostat opens in a new tab">
                <img alt="ManpowerGroup Rotostat logo" width="65" height="54" src="assets/rotostat-logo.png"></a></span>
          </div>
          <div class="disclaimer-logo__list disclaimer-logo__list--primary">
            <span class="disclaimer-logo__item disclaimer-logo__item--1" style="text-align: center !important;">
              <a href="https://www.manpowergroup.com" class="" target="_blank" rel="noopener noreferrer"
                aria-label="Open ManpowerGroup logo in new tab">
                <img alt="ManpowerGroup logo" width="109" height="59"
                  src="assets/ManpowerGroup-Logo-Stacked-White.svg"></a>
            </span>
          </div>
          <p class="disclaimer__text" style="text-align: center !important;">
            A world leader in innovative workforce solutions, ManpowerGroup in India offers comprehensive Workforce
            Management - Recruitment Process Outsourcing (RPO), IT and Non-IT Staffing Solutions,
            Permanent Recruitment, Career Management and Transition and Leadership Training & Development. Our HR
            Solutions support organizations in meeting critical talent needs. We endeavour to be a
            catalyst to our clients and candidates in helping them succeed in the transforming world of work.
          </p>
          <div class="footer_enq_box" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">
            <div class="col-md-4">
              <p style="text-align: center !important;">Enquire Now: <a
                  href="mailto:enquiry@manpowergroup.com">enquiry@manpowergroup.com</a></p>
            </div>
            <div class="col-md-4">
              <p style="text-align: center !important;">For Associates: <a href="tel:1800 419 4001">1800 419 4001</a>
              </p>
            </div>
            <div class="col-md-4">
              <p style="text-align: center !important;">For Business Inquiries: <a href="tel:1800 120 120 000">1800 120
                  120 000</a></p>
            </div>
          </div>
          <p class="disclaimer__copyright"></p>
          <div class="disclaimer-utility__list" style="text-align: center !important;">
            <a class="disclaimer-utility__item" aria-label="" href="https://manpowergroup.co.in/terms-of-use.html" target="_blank">Terms
              of Use</a>
            <a class="disclaimer-utility__item" aria-label=""
              href="https://manpowergroup.co.in/cookie-policy.html" target="_blank">Cookie Policy</a>
            <a class="disclaimer-utility__item" aria-label=""
              href="https://manpowergroup.co.in/privacy-notice.html" target="_blank">Privacy Policy</a>
            <a class="disclaimer-utility__item" aria-label=""
              href="https://manpowergroup.co.in/jobsearch/job_search.aspx" target="_blank">Career</a>
            <a class="disclaimer-utility__item" aria-label="" href="https://manpowergroup.co.in/media-center.html" target="_blank">Media
              Center</a>
            <a class="disclaimer-utility__item" aria-label="" href="https://manpowergroup.co.in/news-release.html" target="_blank">News
              Releases</a>
            <a class="disclaimer-utility__item" aria-label=""
              href="https://manpowergroup.co.in/social-responsibilities.html" target="_blank">Social Responcibilities</a>
            <a href="https://manpowergroup.co.in/data_principal_form.html" target="_blank" class="disclaimer-utility__item">Data Principal Request
              Form</a>
            <a href="https://www.manpowergroup.co.in/MPG_Code_Of_Business_Conduct_And_Ethics_English_Final.pdf"
              target="_blank" class="disclaimer-utility__item">Code of Business Conduct</a>
          </div>
        </div>
      </div>

      <div class="row footer-bottom-links">
        <div class="col-xl-4 col-lg-4 col-sm-12">
          <div class="content richTextFont-0-2-6">
            <p style="text-align: center !important;">© 2025 ManpowerGroup All Rights Reserved.</p>
          </div>
        </div>
        <div class="col-xl-8 col-lg-8 col-sm-12 social-follow">
          <div class="footer-social">
            <!--<div class="title">FOLLOW US</div>-->
            <div class="social-bar">
              <div class="social-icons" aria-expanded="true" style="text-align: center !important;">
                <a href="https://www.linkedin.com/company/209354?trkInfo=tas:ManpowerGroup+India,idx:1-1-1&trk=tyah"
                  class="social-icon" target="_blank" rel="noopener noreferrer" title="LinkedIn"
                  aria-label="LinkedIn">
                  <img src="assets/social-media/Linkedin-White.svg" width="26" alt="LinkedIn" style="max-height: 25px !important;"></a>
                <a href="https://twitter.com/ManpowerGroupIn" class="social-icon" target="_blank"
                  rel="noopener noreferrer" title="Twitter" aria-label="Twitter">
                  <img src="assets/social-media/icon-x.svg" width="40" height="40" alt="Twitter" style="max-height: 25px !important;">
                </a>
                <a href="https://www.threads.net/@manpowergroupind" class="social-icon" target="_blank"
                  rel="noopener noreferrer" title="Threads" aria-label="Threads">
                  <img src="assets/social-media/Threads_logo.png" alt="Threads" style="max-height: 25px !important;">
                </a>
                <a href="http://www.facebook.com/ManpowerGroupIndia" class="social-icon" target="_blank"
                  rel="noopener noreferrer" title="Facebook" aria-label="Facebook">
                  <img src="assets/social-media/Facebook-White.svg" alt="Facebook" style="max-height: 25px !important;">
                </a>
                <a href="https://www.instagram.com/manpowergroupind/" class="social-icon" target="_blank"
                  rel="noopener noreferrer" title="Instagram" aria-label="Instagram">
                  <img src="assets/social-media/Instagram-White.svg" alt="Instagram" style="max-height: 38px !important;">
                </a>
                <a href="https://www.youtube.com/channel/UC1spLrb2N9uUQP_OHbZTPMA" class="social-icon" target="_blank"
                  rel="noopener noreferrer" title="Youtube" aria-label="Youtube">
                  <img src="assets/social-media/youtube-50.png" alt="Youtube" style="max-height: 38px !important;">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>